var map = {
	"./auth.vue": [
		"3bb0",
		"chunk-76164a38"
	],
	"./basic.vue": [
		"1092",
		"chunk-164b5d37"
	],
	"./home.vue": [
		"0f93",
		"chunk-c489ba16"
	],
	"./join.vue": [
		"61fb",
		"chunk-f49c8b5c"
	],
	"./master.vue": [
		"ae37"
	],
	"./play.vue": [
		"9ccd",
		"chunk-d35b8f74",
		"chunk-593eac11",
		"chunk-613d9140"
	],
	"./welcome.vue": [
		"10e8",
		"chunk-319c2368"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a449";
module.exports = webpackAsyncContext;